import { ClientDiscountItemGroupItem } from "features/ClientInfo/types";
import { atom, useAtom } from "jotai";
import { ClientGroup, Client } from "types";

// Clients
export type ClientsState = {
  activeGroupItem: ClientGroup | null;
  activeItems: Client[] | [];
  activeItem: Client | null;
};

type UseClientsStateReturn = {
  clientsState: ClientsState;
  setClientsState: React.Dispatch<React.SetStateAction<ClientsState>>;
};

export const clientsStateAtom = atom<ClientsState>({
  activeGroupItem: null,
  activeItem: null,
  activeItems: [],
});

export const useClientsState = (): UseClientsStateReturn => {
  const [clientsState, setClientsState] = useAtom(clientsStateAtom);

  return { clientsState, setClientsState };
};

// Client information

export type ClientInfoState = {
  activeDiscountItem: ClientDiscountItemGroupItem | null;
  showAddDiscountFields: boolean;
  showAddMarketingFields: boolean;
  selectedMarketingId: string;
};

type UseClientInfoStateReturn = {
  clientInfoState: ClientInfoState;
  setClientInfoState: React.Dispatch<React.SetStateAction<ClientInfoState>>;
};

export const clientInfoStateAtom = atom<ClientInfoState>({
  activeDiscountItem: null,
  showAddDiscountFields: false,
  showAddMarketingFields: false,
  selectedMarketingId: "",
});

export const useClientInfo = (): UseClientInfoStateReturn => {
  const [clientInfoState, setClientInfoState] = useAtom(clientInfoStateAtom);

  return { clientInfoState, setClientInfoState };
};
